import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import useMediaQuery from '@mui/material/useMediaQuery';
import Tooltip from '@mui/material/Tooltip';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';

import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';

import AdminMenuComponent from "../../../components/admin/AdminMenuComponent.js";
import ElementCardForPageComponent from "./ElementCardForPageComponent.js";
import { cyan } from "@mui/material/colors";

const config = require("../../../constants/constants.js")

const CreateCustomerPageComponent = ({
  createCustomerApiRequest,
  reduxDispatch,
  newCustomer,
  deleteCustomer,
  saveAttributeToCatDoc
}) => {

  const [validated, setValidated] = useState(false);
  const [createProductResponseState, setCreateCustomerResponseState] = useState({
    message: "",
    error: "",
  });

  const [title, setTitle] = useState("");
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [telephone, setTelephone] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [via, setVia] = useState("");
  const [cap, setCap] = useState("");
  const [citta, setCitta] = useState("");
  const [provincia, setProvincia] = useState("");
  const [piva, setPiva] = useState("");
  const [codicefiscale, setCodicefiscale] = useState("");

  function createNewCustomer(eventKey) {

    eventKey.preventDefault();
    eventKey.stopPropagation();

    console.log(`title dig =`, title);
    console.log(`name dig =`, name);
    console.log(`surname dig =`, surname);
    console.log(`telephone dig =`, telephone);
    console.log(`mobile dig =`, mobile);
    console.log(`email dig =`, email);
    console.log(`via dig =`, via);
    console.log(`cap dig =`, cap);
    console.log(`citta dig =`, citta);
    console.log(`provincia dig =`, provincia);
    console.log(`piva dig =`, piva);
    console.log(`codicefiscale dig =`, codicefiscale);

    const formInputs = {
      title: title,
      name: name,
      surname: surname,
      telephone: telephone,
      mobile: mobile,
      email: email,
      via: via,
      cap: cap,
      citta: citta,
      provincia: provincia,
      piva: piva,
      codicefiscale: codicefiscale,
      image: "",
    };

    createCustomerApiRequest(formInputs);
    window.location.assign('/admin/customers')
  }

  function gotoIndietro(eventKey) {
    eventKey.preventDefault();
    eventKey.stopPropagation();

    window.location.assign('/admin/customers')
  }

  return (

    <Box sx={{ flexGrow: 1 }}>

      <Grid container spacing={2}>

        <AdminMenuComponent></AdminMenuComponent>

        <Box
          paddingLeft={{ xs: 3, md: 3 }}
        >

          <Breadcrumbs separator="›" aria-label="breadcrumb"
            size={{ xs: 12, md: 4 }}
            paddingTop={{ xs: 0, md: 0 }}
            paddingLeft={{ xs: 0, md: 0 }}
            paddingRight={{ xs: 1, md: 8 }}
            spacing={{ xs: 2, md: 2 }}
          >
            <Link underline="hover" color="inherit" href="/admin/welcome">
              {config.BC_ADMIN}
            </Link>
            <Link underline="hover" color="inherit" href="/admin/customers">
              {config.BC_ADMIN_CUSTOMERS}
            </Link>
            <Typography sx={{ color: 'text.primary' }}>{config.BC_ADMIN_CUSTOMERS_CREATE}</Typography>
          </Breadcrumbs>

          <Stack
            sx={{ flexDirection: { xs: "row", md: "row" }, paddingTop: 2, paddingLeft: 0, paddingRight: 0, }}
          >
            <Typography
              sx={{ paddingTop: 0, paddingLeft: 0, paddingRight: 0, }}
              variant="h4"
            >
              <b>Crea cliente</b>&nbsp;
            </Typography>
          </Stack>

          <Box
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              height: 20
            }}
          />

          <Paper
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              background: '#cce0e6'
            }}
            elevation={6}
          >

            <Stack
              useFlexGap
              sx={{
                flexDirection: { xs: "column", md: "row" },
                paddingTop: 2, paddingLeft: 0, paddingRight: 0,
                flexWrap: 'wrap'
              }}
            >

              <TextField id="id-title" label="Cliente" variant="outlined" defaultValue={title}
                sx={{
                  width: "35ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setTitle(event.target.value);
                }}
              />

              <TextField id="id-name" label="Nome" variant="outlined" defaultValue={name}
                sx={{
                  width: "35ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setName(event.target.value);
                }}
              />

              <TextField id="id-surname" label="Cognome" variant="outlined" defaultValue={surname}
                sx={{
                  width: "35ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setSurname(event.target.value);
                }}
              />

              <TextField id="id-telephone" label="Telefono" variant="outlined" defaultValue={telephone}
                sx={{
                  width: "25ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setTelephone(event.target.value);
                }}
              />

              <TextField id="id-mobile" label="Mobile" variant="outlined" defaultValue={mobile}
                sx={{
                  width: "25ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setMobile(event.target.value);
                }}
              />

              <TextField id="id-email" label="Email" variant="outlined" defaultValue={email}
                sx={{
                  width: "35ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setEmail(event.target.value);
                }}
              />

              <TextField id="id-via" label="Via" variant="outlined" defaultValue={via}
                sx={{
                  width: "35ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setVia(event.target.value);
                }}
              />

              <TextField id="id-cap" label="CAP" variant="outlined" defaultValue={cap}
                sx={{
                  width: "15ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setCap(event.target.value);
                }}
              />

              <TextField id="id-citta" label="Città" variant="outlined" defaultValue={citta}
                sx={{
                  width: "20ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setCitta(event.target.value);
                }}
              />

              <TextField id="id-provincia" label="Provincia" variant="outlined" defaultValue={provincia}
                sx={{
                  width: "15ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setProvincia(event.target.value);
                }}
              />

              <TextField id="id-piva" label="Partita iva" variant="outlined" defaultValue={piva}
                sx={{
                  width: "25ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setPiva(event.target.value);
                }}
              />

              <TextField id="id-codicefiscale" label="Codice fiscale" variant="outlined" defaultValue={codicefiscale}
                sx={{
                  width: "25ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setCodicefiscale(event.target.value);
                }}
              />

            </Stack>

            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: "row", md: "row" },
                alignItems: "center",
                justifyContent: "center"
              }}
            >

              <Button
                type="button"
                variant="contained"
                color="warning"
                onClick={(e) => { gotoIndietro(e); }}
                sx={{
                  width: "12ch",
                  p: 1,
                  m: 1,
                }}
              >
                Indietro
              </Button>

              <Button
                variant="contained"
                type="submit"
                color="success"
                onClick={(e) => { createNewCustomer(e); }}
                sx={{
                  width: "12ch",
                  p: 1,
                  m: 1,
                }}
              >
                Crea
              </Button>
              {createProductResponseState.error ?? ""}

            </Box>

            <Box
              sx={{
                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                height: 20
              }}
            />

          </Paper>

          <Box
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              height: 40
            }}
          />

        </Box>

      </Grid>

    </Box>

  );
};

export default CreateCustomerPageComponent;
